export abstract class GeneralValueObject {
  readonly title: string;
  readonly id: string;

  constructor(id: string, title: string) {
    this.title = title;
    this.id = id;
  }
}
